<div class="wrapper mb-5">
    <div class="row align-items-center m-0" style="padding: 10px;">
        <img class="p-2" src="./assets/icons/arrow.svg">
        <span class="label-title ml-2 mr-3">Editar</span>
    </div>
    <div class="component-box container-fluid">
        <div class="row m-2">
            <div class="col-12 component-title pt-4">Editar Gestor</div>
            <form class="col-12" [formGroup]="gestorConviteFormGroup" #gestorConviteForm="ngForm"
                (ngSubmit)="onSubmit(gestorConviteFormGroup.value)">
                <div class="py-2 container-fluid">
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 py-2 border-right">
                            <div class="custom-pr-5 mb-5">
                                <div class="custom-input-container">
                                    <input formControlName="nome" id="nome" class="custom-input-outline" type="text"
                                        #inName (blur)="InNameOnBlur(inName.value)" (focus)="InNameOnFocus()"
                                        [readonly]="cedenteGestor.gestor.gestorGuid !== currentUser.token.userReferenceId" />
                                    <label class="custom-label-outline" for="nome">Nome:</label>
                                </div>
                                <div *ngIf="
                                        (form.nome.invalid &&
                                            (form.nome.dirty ||
                                                form.nome.touched)) ||
                                        InNameHasNumber
                                    " class="text-danger">
                                    <div *ngIf="form.nome?.errors?.required">
                                        Nome é obrigatório!
                                    </div>
                                    <div *ngIf="form.nome?.errors?.maxlength">
                                        Nome deve conter no máximo 100
                                        caracteres.
                                    </div>
                                    <div *ngIf="form.nome?.errors?.minlength">
                                        Nome deve conter no mínimo 3 caracteres.
                                    </div>
                                    <div *ngIf="InNameHasNumber">
                                        O nome do gestor não pode ter dígitos
                                        numéricos.
                                    </div>
                                </div>
                            </div>

                            <div class="custom-pr-5 mb-5">
                                <div class="custom-input-container">
                                    <input formControlName="email" id="email" class="custom-input-outline" type="email"
                                        [readonly]="cedenteGestor.gestor.gestorGuid !== currentUser.token.userReferenceId" />
                                    <label class="custom-label-outline" for="email">E-mail:</label>
                                </div>
                                <div *ngIf="
                                        form.email.invalid &&
                                        (form.email.dirty || form.email.touched)
                                    " class="text-danger">
                                    <div *ngIf="form.email.errors.required">
                                        E-mail é obrigatório!
                                    </div>
                                    <div *ngIf="form.email.errors.email">
                                        Formato de e-mail inválido!
                                    </div>
                                </div>
                            </div>

                            <div class="custom-pr-5 mb-5">
                                <div class="custom-input-container">
                                    <input autocomplete="off" formControlName="telefone" id="telefone" class="custom-input-outline" type="text"  [textMask]="{mask: telefoneCelularMask}"
                                        readonly />
                                    <label class="custom-label-outline" for="telefone">Telefone Celular:</label>

                                </div>
                                <div *ngIf="form.telefone.invalid && (form.telefone.dirty || form.telefone.touched)" class="text-danger">
                                    <div *ngIf="form.telefone.errors.required">
                                        Telefone é obrigatório
                                    </div>
                                    <div *ngIf="form.telefone.errors.celular">
                                        Telefone inválido
                                    </div>
                                    <div *ngIf="form.telefone.errors.isCellPhone">
                                        Telefone deve conter o dígito 9
                                    </div>
                                    <div *ngIf="form.telefoneNumero.errors.telefone">
                                        Telefone inválido
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                            <div class="custom-pr-5 mb-5">
                                <div class="custom-input-container">
                                    <input [textMask]="{
                                            mask: MASKS.cpf.textMask
                                        }" formControlName="cpf" id="cpf" class="custom-input-outline" type="text"
                                        readonly />
                                    <label class="custom-label-outline" for="cpf">CPF:</label>
                                </div>
                                <div *ngIf="
                                        form.cpf.invalid &&
                                        (form.cpf.dirty || form.cpf.touched)
                                    " class="text-danger">
                                    <div *ngIf="form.cpf.errors.required">
                                        CPF é obrigatório.
                                    </div>
                                    <div *ngIf="form.cpf.errors.cpf">
                                        CPF inválido.
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="!isResponsavel" class="div-select-create custom-pr-5 py-2">
                                <div class="perfil-title">Perfis:</div>
                                <div class="custom-input-container form-check-inline my-2"
                                    *ngFor="let listPerfis of perfisList">
                                    <input (change)="isChecked()" [attr.id]="
                                            'perfil-' + listPerfis.perfilId
                                        " [disabled]="cedenteGestor.gestor.gestorGuid === currentUser.token.userReferenceId"
                                        class="checkbox mx-2" [(ngModel)]="listPerfis.selected"
                                        [ngModelOptions]="{ standalone: true }" type="checkbox" />
                                    <label [attr.for]="
                                            'perfil-' + listPerfis.perfilId
                                        " class="form-check-label">{{ listPerfis.nome }}</label>
                                </div>
                                <div *ngIf="perfilSelected === false">
                                    <span class="text-danger">Selecione ao menos um perfil.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row button-container mt-5 mb-3">
                    <div class="col-12 text-right">
                        <button class="custom-button-full btn-back custom-button-previous" (click)="goToBack()">
                            Voltar
                        </button>

                        <button type="submit" class="custom-button-full">
                            Editar
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
